<template>
  <el-container class="layout-container">
    <el-aside width="220px" class="aside">
      <div class="logo">
        <img src="../assets/image/baipu.png" alt="logo" class="logo-img">
      </div>
      <el-menu
        :default-active="$route.path"
        background-color="#ffffff"
        text-color="#606266"
        active-text-color="#409EFF"
        unique-opened
        router>
        <el-submenu index="user">
          <template slot="title">
            <i class="el-icon-s-grid"></i>
            <span>项目列表</span>
          </template>
          <el-menu-item index="/project/compound-list/bar">项目列表</el-menu-item>
        </el-submenu>
      </el-menu>
    </el-aside>
    
    <el-container>
      <el-header height="60px" class="header">
        <div class="header-right">
          <el-dropdown @command="handleCommand">
            <span class="el-dropdown-link">
              <i class="el-icon-user-solid avatar-icon"></i>
              <!-- 显示登录用户的名字 -->
              <span>{{ userInfo.user_name || '未知用户' }}</span>
              <i class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="logout">退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </el-header>
      <el-main class="main">
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import axios from 'axios';
export default {
  name: 'MainLayout',
  data() {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {};
    // console.log('从 localStorage 获取的用户信息:', userInfo);
    return {
      userInfo
    };
  },
  methods: {
    async handleCommand(command) {
      if (command === 'logout') {
        this.$confirm('确定要退出登录吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            // 调用后端退出登录接口，假设接口地址为 api/logout
            await axios.post('api/logout', {
              // 可以根据后端要求传递必要的参数，如 token
              token: localStorage.getItem('token')
            });
            // 移除本地存储的 token 和 userInfo
            localStorage.removeItem('token');
            localStorage.removeItem('userInfo');
            // 跳转到登录页面
            this.$router.push('/login');
            this.$message({
              type: 'success',
              message: '退出登录成功'
            });
          } catch (error) {
            console.error('退出登录失败:', error);
            this.$message({
              type: 'error',
              message: '退出登录失败，请稍后重试'
            });
          }
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消退出登录'
          });
        });
      }
    }
  }
}
</script>

<style scoped>
.layout-container {
  height: 100vh;
}

.aside {
  /* background-color: #ffffff; */
  height: 100vh;
  overflow-x: hidden;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
}

.logo {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-color: #ffffff;
  border-bottom: 1px solid #f0f0f0; */
}

.logo-img {
  height: 120px;
}

.logo-text {
  /* color: #fff; */
  font-size: 16px;
  font-weight: 600;
  white-space: nowrap;
}

.header {
  /* background-color: #fff;
  border-bottom: 1px solid #e6e6e6; */
  display: flex;
  align-items: center;
  justify-content: flex-end;
  padding: 0 20px;
}

.header-right {
  display: flex;
  align-items: center;
}

.el-dropdown-link {
  display: flex;
  align-items: center;
  color: #606266;
  cursor: pointer;
}

.avatar-icon {
  font-size: 20px;
  margin-right: 8px;
  color: #409EFF;
}

:deep(.el-menu) {
  border-right: none;
}

:deep(.el-menu-item),
:deep(.el-submenu__title) {
  height: 50px;
  line-height: 50px;
  font-size: 14px;
}

:deep(.el-menu-item) {
  padding: 0 16px !important;
}

:deep(.el-menu-item.is-active) {
  /* background-color: #e6f7ff !important; */
  color: #1890ff !important;
  border-right: 3px solid #1890ff;
}

:deep(.el-submenu .el-menu-item) {
  min-width: 220px;
  padding-left: 48px !important;
  /* background-color: #ffffff; */
}

:deep(.el-menu-item:hover),
:deep(.el-submenu__title:hover) {
  /* background-color: #f5f5f5 !important; */
  color: #1890ff !important;
}

:deep(.el-menu-item i),
:deep(.el-submenu__title i) {
  margin-right: 10px;
  font-size: 16px;
  /* color: #909399; */
}

:deep(.el-menu-item.is-active i) {
  color: #1890ff;
}

:deep(.el-submenu.is-active .el-submenu__title) {
  color: #1890ff !important;
}

:deep(.el-submenu.is-active .el-submenu__title i) {
  color: #1890ff !important;
}

:deep(.el-submenu__title) {
  padding-left: 16px !important;
}

.main {
  /* background-color: #f2f3f5; */
  padding: 20px;
  min-height: calc(100vh - 60px);
}
</style>